// extracted by mini-css-extract-plugin
export var promo = "welcome-module--promo--1RdQ2";
export var buttonGroup = "welcome-module--button-group--k7BRu";
export var promoInner = "welcome-module--promo-inner--1IBNu";